import apolloClient from '../../utils/apollo-client';
import { getQuote as query } from '../graphql/quote';

export default async function (quoteId) {
  const response = await apolloClient().then((client) =>
    client.query({
      query,
      variables: { quoteId }
    })
  );
  return response.data.getQuote;
}
